import PropTypes from 'prop-types'
import { Row, Col, Alert, Button, Card, CardBody, Container } from "reactstrap"
import React, { useEffect, useState } from "react"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"


import { Field, Form } from '@availity/form'
import '@availity/yup'
import * as yup from 'yup'

// action
import { userForgetPassword, userChangePassword } from "../../store/actions"

// import images
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo.svg"

const ForgetPasswordPage = props => {
  const { onUserForgetPassword, onUserChangePassword } = props
  const [user, setUser] = useState()
  const [email, setEmail] = useState()
  const [password, setPassword] = useState("")
  const [code, setCode] = useState("")
  const [codeSent, setCodeSent] = useState(false)

  function handleResetSubmit() {
   console.log(user)
    onUserForgetPassword(user)
    setCodeSent(true)
  }

  function handleCodeSubmit() {
    onUserChangePassword(user,code,password, props.history)
  }

  return (
    <React.Fragment>
     <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset Password</h5>
                        <p>Enter in your user to get a code sent to your email to reset your password.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
 <div className="p-2">
                    {props.forgetError && props.forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {props.forgetError}
                      </Alert>
                    ) : null}
                    {props.forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {props.forgetSuccessMsg}
                      </Alert>
                    ) : null}
     {props.changePasswordError && (
         <Alert color="danger">{props.changePasswordError}</Alert>
     )}

     {props.changePasswordSuccess && (
         <Alert color="success">{props.changePasswordSuccess}</Alert>
     )}

                    {!codeSent ? (
                    <Form
                      className="form-horizontal"
                      onSubmit={handleResetSubmit}
                      initialValues={{
                          user: '',
                          password: '',
                      }}
                      validationSchema={yup.object().shape({
                          code: yup
                              .string()
                              .required("Verification code is required"),

                          newPassword: yup
                              .string()
                              .required("New password is required")
                              .min(8, "Password must be at least 8 characters")
                              .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                              .matches(/[a-z]/, "Password must contain at least one lowercase letter")
                              .matches(/[0-9]/, "Password must contain at least one number"),

                          confirmPassword: yup
                              .string()
                              .required("Please confirm your password")
                              // IMPORTANT: must refer to newPassword
                              .oneOf([yup.ref("newPassword"), null], "Passwords must match")
                      })}
                    >

                      <div className="form-group">
                        <Field
                          name="user"
                          label="User"
                          className="form-control"
                          type="text"
                          onChange={e => setUser(e.target.value)}
                        />
                      </div>
                      <Row className="form-group">
                        <Col className="text-right">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="button"
                             onClick={() => handleResetSubmit()}
                          >
                            Reset
                          </button>
                        </Col>
                      </Row>
                    </Form>) : null}



     {codeSent && !props.changePasswordSuccess && (
                    <Form
                      className="form-horizontal"
                      onSubmit={handleCodeSubmit}
                      initialValues={{
                          user: '',
                          password: '',
                      }}
		      validationSchema={yup.object().shape({
  code: yup
    .string()
    .required('Code is required'), // Fix typo: `isRequired` -> `required`
  newPassword: yup
    .string()
    .required('New Password is required')
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
      'Password must be 8 or more characters, with at least 1 number, 1 uppercase letter, and 1 lowercase letter.'
    )
})}
                    >
                        <div className="form-group">
                            <Field
                                name="code"
                                label="Verification Code"
                                className="form-control"
                                type="text"
                                value={code}
                                onChange={e => setCode(e.target.value)}
                            />
                        </div>
                        <div className="form-group">

                           <Field
                               name="newPassword"
                               label="New Password"
                               className="form-control"
                               type="text"
                               value={password}
                               onChange={e => setPassword(e.target.value)}
                           />
                         </div>
                            <Row className="form-group">
                                <Col className="text-right">
                                   <Button color="primary">Submit</Button>
                                </Col>
                           </Row>
                       </Form>)}

     {codeSent && props.changePasswordSuccess!=undefined && (
         <div className="mt-3">
             <Button color="primary" onClick={() => props.history.push("/login")}>
                 Return to Login
             </Button>
         </div>
     )}


 </div>
                </CardBody>
              </Card>
                <div className="mt-5 text-center">
                    <p>
                        Go back to{" "}
                        <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Permaculture Gardens, LLC.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>




    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func,
  userChangePassword: PropTypes.func
}

const mapStateToProps = (state) => {
    const {
        forgetError,
        forgetSuccessMsg,
        changePasswordError,
        changePasswordSuccess
    } = state.ForgetPassword

    return {
        forgetError,
        forgetSuccessMsg,
        changePasswordError,
        changePasswordSuccess
    }
}


const mapDispatchToProps = dispatch => ({
   onUserForgetPassword: user => dispatch(userForgetPassword(user)),
   onUserChangePassword: (user,code,password, history) => dispatch(userChangePassword(user,code,password, history))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ForgetPasswordPage))

